module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('request-status', {
    attrs: {
      "request": _vm.invoicesRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-menu', {
    staticClass: "visible-xs-only",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Views")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("setmain", "kanban")
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("view_week")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Progress")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": "/financials/"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("account_balance_wallet")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                Statement\n              ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("setmain", "overdueReport")
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("alarm_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Past due")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": "/transactions"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("paid")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              Payments\n            ")])], 1)], 1), _vm._v(" "), _c('v-subheader', [_vm._v("\n          Bulk actions")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("setmain", "gallery")
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("done_all")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(_vm.$t('bulk.invoiceable')))])], 1)], 1)], 1)], 1), _vm._v(" "), [_c('v-btn', {
    attrs: {
      "loading": _vm.invoicesRequest.loading,
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("reload")
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("filter_list")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showFilters),
      callback: function($$v) {
        _vm.showFilters = $$v
      },
      expression: "showFilters"
    }
  }, [_vm._v(" "), _c('invoice-filter', {
    attrs: {
      "facets": _vm.facets,
      "params": _vm.params
    },
    on: {
      "update:params": function($event) {
        _vm.params = $event
      },
      "close": function($event) {
        _vm.showFilters = false
      }
    }
  }, [_c('v-switch', {
    attrs: {
      "hide-messages": "",
      "dense": "",
      "label": _vm.dateTypeString
    },
    model: {
      value: (_vm.localUseDateDue),
      callback: function($$v) {
        _vm.localUseDateDue = $$v
      },
      expression: "localUseDateDue"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$store.dispatch("ACTIVATE_RANGE_PICKER")
      }
    }
  }, [_c('v-icon', {
    staticClass: "hidden-xs-only",
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-2 hidden-xs-only",
    attrs: {
      "vertical": ""
    }
  }), _vm._v("\n      " + _vm._s(_vm.$tc('title.summary', _vm.totalItems, _vm.summaryParams)) + "\n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withSearch) ? _c('v-text-field', {
    staticClass: "hidden-xs-only mx-3",
    attrs: {
      "placeholder": "Search on invoice number, payment reference, or invoice title",
      "clearable": "",
      "prepend-icon": "search"
    },
    on: {
      "input": _vm.debouncedSearch,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.searchString = "";
        _vm.debouncedSearch()
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showServerSearch) ? [(_vm.serverSearch) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "outline": ""
    },
    on: {
      "click": _vm.searchOnServer
    }
  }, [_vm._v("Search")]) : _vm._e(), _vm._v(" "), (_vm.searchString && _vm.searchString.length > 2) ? _c('v-checkbox', {
    staticClass: "hidden-xs-only caption pt-4",
    attrs: {
      "flat": "",
      "hide-messages": "",
      "dense": "",
      "small": "",
      "label": "Search on server"
    },
    model: {
      value: (_vm.serverSearch),
      callback: function($$v) {
        _vm.serverSearch = $$v
      },
      expression: "serverSearch"
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "fab": _vm.$vuetify.breakpoint.xs,
      "small": _vm.$vuetify.breakpoint.xs,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.launchInvoiceDialog({
          touchClear: Math.random()
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("New Invoice")])], 1)], _vm._v(" "), _c('v-layout', {
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [_vm._t("extra-nav"), _vm._v(" "), _c('span', {
    staticClass: "mt-2"
  }, [_vm._v("\n      " + _vm._s(_vm.totalItems) + " invoices found\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.page && _vm.totalPages > 1) ? [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.page <= 1
    },
    on: {
      "click": function($event) {
        _vm.$emit("update:page", (_vm.page - 1))
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('span', {
    staticClass: "mt-2"
  }, [_vm._v(_vm._s(_vm.page) + " of " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.page === _vm.totalPages
    },
    on: {
      "click": function($event) {
        _vm.$emit("update:page", (_vm.page + 1))
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)] : _vm._e()], 2)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15c1ce12","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/layout/Toolbar.vue
// module id = 1335
// module chunks = 9